import { render, staticRenderFns } from "./GroupArchivePage.vue?vue&type=template&id=089a6562&"
import script from "./GroupArchivePage.vue?vue&type=script&lang=js&"
export * from "./GroupArchivePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports